"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styles = require("@material-ui/core/styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  root: {
    "&[role=group] + *": {
      borderTop: "1px solid",
      borderTopColor: theme.palette.divider,
      marginTop: theme.spacing(1.5),
      paddingTop: theme.spacing(1.5)
    },
    "& + &[role=group]": {
      borderTop: "1px solid",
      borderTopColor: theme.palette.divider,
      marginTop: theme.spacing(1.5),
      paddingTop: theme.spacing(1.5),
      "& + *": {
        borderTop: "1px solid",
        borderTopColor: theme.palette.divider,
        marginTop: theme.spacing(1.5),
        paddingTop: theme.spacing(1.5)
      }
    }
  }
}));

const ActionMenuItem = ({
  className,
  role,
  children
}) => {
  const classes = useStyles();
  return _react.default.createElement("li", {
    className: className || classes.root,
    role: role
  }, children);
};

var _default = ActionMenuItem;
exports.default = _default;
module.exports = exports.default;